var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHintsLogoApp = function SvgHintsLogoApp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_111_6034)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.6667,
    height: 80.6667,
    rx: 16,
    fill: "#002864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 67.3333L60.3308 20.3359L66.2683 37.1432C66.2683 37.1432 69.6936 46.5061 64.2584 51.9413C58.8231 57.3766 54.1647 64.5926 46.6741 64.5926C39.1835 64.5926 16.4394 64.228 13.3333 67.3333Z",
    fill: "#3336BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 67.3333L60.3308 20.3359L43.5235 14.3983C43.5235 14.3983 34.1606 10.973 28.7253 16.4083C23.29 21.8436 16.074 26.5019 16.074 33.9925C16.074 41.4831 16.4394 64.228 13.3333 67.3333Z",
    fill: "url(#paint0_linear_111_6034)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3316 20.3359L13.3341 67.3333C16.4585 64.2328 25.3183 44.1546 28.3082 37.5277C31.2981 30.9008 37.5318 25.9638 42.9957 20.5413C48.4596 15.1187 52.5528 16.9934 52.7685 17.0921L60.3316 20.3359Z",
    fill: "#959FE5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_111_6034",
    x: -32,
    y: -32,
    width: 144.667,
    height: 144.667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_111_6034"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_111_6034",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_111_6034",
    x1: 4.34442,
    y1: 58.3448,
    x2: 51.3412,
    y2: 11.3461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    stopColor: "#FEC986"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2286,
    stopColor: "#FACA93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3471,
    stopColor: "#F3CDA7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#EAD0C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5869,
    stopColor: "#DED5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6164,
    stopColor: "#DBD6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8FFFF"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHintsLogoApp);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,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";